//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-haut.svg';
import throttle from 'lodash/throttle';
const SCROLL_THRESHOLD = 230;
export default {
  name: 'MdmBackToTop',

  data() {
    return {
      show: false
    };
  },

  mounted() {
    this.show = window.scrollY > SCROLL_THRESHOLD;
    this.bindScrollTop();
  },

  destroyed() {
    this.unbindScrollTop();
  },

  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },

    bindScrollTop() {
      window.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
    },

    unbindScrollTop() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    handleScroll: throttle(function handleScroll() {
      this.show = window.scrollY > SCROLL_THRESHOLD;
    }, 200)
  }
};